import React, { useEffect, useState, useContext } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import { usePrimarySales } from '../../hooks/Sales/usePrimarySales'
import { ROUTES } from '../../shared/constants'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { ProductContext } from '../../context api/Product/ProductContext'
import { useStore } from '../../hooks/CompanyConfiguration/useStore'
import { useProduct } from '../../hooks/Features/useProduct'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import { sortByName } from '../../shared/constants'

export default function AddPrimarySales({ primarySales }) {
  const { addPrimarySales, updatePrimarySales, loading } = usePrimarySales()

  const [primarySalesForm, setPrimarySalesForm] = useState({
    store: '',
    saleType: '',
    orderNumber: '',
    invoiceNumber: '',
    invoiceDate: new Date(),
    quantity: '',
    amount: '',
    product: '',
  })

  const [error, setError] = useState(false)

  const { products } = useContext(ProductContext)
  const { stores } = useContext(ConfigurationContext)
  const { getAllProducts } = useProduct()
  const { getAllStore } = useStore()

  useEffect(() => {
    getAllProducts()
    getAllStore()
  }, [])

  const handleAddPrimarySales = () => {
    if (primarySales) {
      updatePrimarySales({
        ...primarySalesForm,
        primarySalesId: primarySales._id,
      })
    } else {
      addPrimarySales({
        ...primarySalesForm
      })
    }
  }

  useEffect(() => {
    if (primarySales) {
      setPrimarySalesForm({
        ...primarySalesForm,
        store: primarySales.store && primarySales.store._id,
        saleType: primarySales.saleType,
        orderNumber: primarySales.orderNumber,
        invoiceNumber: primarySales.invoiceNumber,
        quantity: primarySales.quantity,
        amount: primarySales.amount,
        product: primarySales.product._id,
      })
    }
  }, [primarySales])

  const data = [
    { label: 'Store', value: primarySalesForm.store, name: 'store', options: sortByName(stores), fieldName: 'name', fieldValue: '_id' },
    {
      label: 'Sale Type',
      value: primarySalesForm.saleType,
      name: 'saleType',
      options: [
        { name: 'Primary', _id: 'PRIMARY' },
        { name: 'Secondary', _id: 'SECONDARY' },
      ],
      fieldName: 'name',
      fieldValue: '_id',
    },
    { label: 'Order Number', value: primarySalesForm.orderNumber, name: 'orderNumber', type: 'number' },
    { label: 'Invoice Number', value: primarySalesForm.invoiceNumber, name: 'invoiceNumber', type: 'number' },
    { label: 'Invoice Date', value: primarySalesForm.invoiceDate, name: 'invoiceDate', type: 'DATE', maxDate: new Date() },
    { label: 'Quantity', value: primarySalesForm.quantity, name: 'quantity', type: 'number', conditions: [{ cond: (value) => value <= 0, message: "Quantity should be Greater than 0" }] },
    { label: 'Amount', value: primarySalesForm.amount, name: 'amount', type: 'number', conditions: [{ cond: (value) => value <= 0, message: "Amount should be Greater than 0" }] },
    { label: 'Product', value: primarySalesForm.product, name: 'product', options: sortByName(products, 'products'), fieldName: 'name', fieldValue: '_id', fieldName2: 'sku' },
  ]

  return (
    <Layout heading="Primary Sales" heading2={primarySales ? 'Edit' : 'Add'} url1={ROUTES.PRIMARY_SALES} none>
      <HeaderTabLayout
        heading={`${primarySales ? 'Edit' : 'Add'} Primary Sales`}
        content={<CustomAddForm state={primarySalesForm} setState={setPrimarySalesForm} data={data} setError={setError} />}
        addContent={handleAddPrimarySales}
        redirect={ROUTES.PRIMARY_SALES}
        loading={loading}
        buttonDisabled={error}
        state={primarySalesForm} setState={setPrimarySalesForm} 
      />
    </Layout>
  )
}
